<template>
  <div id="ShareDrawer" :class="{open}">
    <a class="share-drawer-button" @click="open = !open">
      <ShareIcon v-if="!open"/>
      <div class="close-button" v-if="open">
        <span class="close-button--bar"></span>
        <span class="close-button--bar"></span>
      </div>
    </a>
    <a class="share-button share-button--facebook" href="javascript:void(0)" @click="shareFacebook()">
      <FacebookIcon class="fb-icon"/>
    </a>
    <a class="share-button share-button--twitter" href="javascript:void(0)" @click="shareTwitter()">
      <TwitterIcon/>
    </a>
    <a class="share-button share-button--google" href="javascript:void(0)" @click="shareGoogle()">
      <GooglePlusIcon/>
    </a>
    <a class="share-button share-button--linkedin" href="javascript:void(0)" @click="shareLinkedIn()">
      <LinkedinIcon/>
    </a>
  </div>
</template>
<script>
import ShareIcon from '../assets/share.svg'
import FacebookIcon from '../assets/social-facebook.svg'
import TwitterIcon from '../assets/social-twitter.svg'
import GooglePlusIcon from '../assets/social-google-plus.svg'
import LinkedinIcon from '../assets/social-linkedin.svg'

export default {
  name: 'ShareDrawer',
  components: {
    ShareIcon,
    FacebookIcon,
    TwitterIcon,
    GooglePlusIcon,
    LinkedinIcon
  },
  data: () => ({
    open: false,
    shareText: 'Schneider Electric is combating climate change through innovation. See how EcoStruxure™ solutions are empowering sustainability, boosting bottom lines in every industry, and leading the digital transformation of energy management and automation.'
  }),
  methods: {
    shareTwitter () {
      window.open(`https://twitter.com/intent/tweet?text=${this.shareText}&url=${window.location.href}`,
        'share', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=550,height=420')
      this.open = false
    },
    shareFacebook () {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
        'share', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=626,height=436')
      this.open = false
    },
    shareLinkedIn () {
      window.open(`https://www.linkedin.com/shareArticle?url=${window.location.href}`,
        'share', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=520,height=570')
      this.open = false
    },
    shareGoogle () {
      window.open(`https://plus.google.com/share?url=${window.location.href}`,
        'share', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600')
      this.open = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
#ShareDrawer {
  @media(min-width: $screen-sm-min) {
    display: flex;
  }
  display: none;
  transition: .2s right;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  background: $white;
  position: fixed;
  width: 180px;
  height: 53px;
  justify-content: space-between;
  align-items: center;
  right: -130px;
  bottom: 150px;
  padding: 14px;
  padding-top: 16px;
  box-shadow: 0px 0px 28px 0px rgba(0,0,0,0.04);
  &.open {
    right: 0;
  }
  a {
    display: block;
    width: 22px;
    cursor: pointer;
  }

  svg {
    fill: #c1c1c3;
    margin-top: 2px;
  }
  .share-drawer-button {
    margin-right: 14px;
  }

  .close-button {
    cursor: pointer;
    height: 25px;
    .close-button--bar {
      display: block;
      width: 25px;
      height: 2px;
      margin-top: 3px;
      background: #C1C1C3;
      &:nth-child(1) {
        transform: translate(0, 10px) rotate(45deg);
      }
      &:nth-child(2) {
        transform: translate(0, 4px) rotate(-45deg) ;
      }
    }
  }

  .share-button {
    transition: .2s background;
    display: flex;
    width: 24px;
    height: 24px;
    background: #b2b2b2;
    // border-radius: 5px;
    color: #fff;
    line-height: 24px;
    text-align: center;
    justify-content: center;
    svg {
      width: 65%;
      height: 65%;
      margin-top: 4px;
      fill: $white;
    }

    &--facebook {
      &:hover {
        background: $brand-facebook;
      }
    }
    &--twitter {
      &:hover {
        background: $brand-twitter;
      }
    }
    &--google {
      &:hover {
        background: $brand-google;
      }
    }
    &--linkedin {
      &:hover {
        background: $brand-linkedin;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShareDrawer.vue